import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useGetSingleLeaveReq } from "../../hooks/useManagement";
import { useChangeStatusLeaveRequest } from "../../hooks/useCrm";

export const LeaveReqItemModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const [form, setForm] = useState();
  const { data } = useGetSingleLeaveReq({
    leave_request_id: item?.IdLeaveRequest,
  });

  const { mutateAsync: changeStatusLeaveRequest } =
    useChangeStatusLeaveRequest();

  const handleChangeStatusLeaveRequest = async (status, id) => {
    await changeStatusLeaveRequest({ ...form, status, leave_request_id: id });
  };

  const request = data?.data?.data;

  return (
    <BootstrapModal
      modaltitle="درخواست مرخصی"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", rowGap: "15px" }}>
        <div>
          <label
            style={{
              marginBottom: "10px",
              fontSize: "14px",
            }}
          >
            متن درخواست:
          </label>
          <div>{data?.data?.data?.Description}</div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              marginBottom: "10px",
              fontSize: "14px",
            }}
          >
            نظر سرپرست:
          </label>
          <input
            style={{
              padding: "5px 10px",
              borderRadius: "6px",
            }}
            type="text"
            placeholder="نظر خود را بنویسید"
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </div>
        <div className="col-12 d-flex">
          <Button
            bgColor="#009ef7"
            className="m-1"
            color="#fff"
            onclick={() => {
              handleChangeStatusLeaveRequest(3, request?.IdLeaveRequest);
              handleClose();
            }}
          >
            تایید درخواست
          </Button>
          <Button
            bgColor="#f1416c"
            className="m-1"
            color="#fff"
            onclick={() => {
              handleChangeStatusLeaveRequest(2, request?.IdLeaveRequest);

              handleClose();
            }}
          >
            رد درخواست{" "}
          </Button>
          <Button
            bgColor="transparent"
            className="m-1"
            color="#000"
            border="#000"
            onclick={handleClose}
          >
            بستن
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
